import moment from "moment";

const DateTime = ({ value }) => {
  return <div>{moment(value).format("YYYY-MM-DD HH:mm")}</div>;
};

export default DateTime;
